/* eslint-disable no-invalid-this, sonarjs/function-return-type */
import * as yup from 'yup';

declare module 'yup' {
    interface StringSchema {
        idn: (message?: string, maxLength?: number) => StringSchema;
        personaName: () => StringSchema;
        flowTitle: () => StringSchema;
        emailStrict: () => StringSchema;
        version: (message?: string) => StringSchema;
        urlList: () => StringSchema;
    }
}

const MAX_IDN_LENGTH = 90;
yup.addMethod(
    yup.string,
    'idn',
    function idn(message, maxLength: number = MAX_IDN_LENGTH) {
        return this.matches(/^([a-z_]\w*)$/i, {
            message:
                message ??
                'Idn must start with a letter or underscore, and can only contain letters, numbers or underscores.'
        }).max(maxLength, `Idn must be less than ${maxLength} characters.`);
    }
);

yup.addMethod(yup.string, 'personaName', function personaName() {
    const MAX_PERSONA_NAME_LENGTH = 60;
    return this.trim().max(
        MAX_PERSONA_NAME_LENGTH,
        'Name must be less than 60 characters.'
    );
});

yup.addMethod(yup.string, 'flowTitle', function flowTitle() {
    const MAX_FLOW_TITLE_LENGTH = 80;
    return this.trim()
        .max(
            MAX_FLOW_TITLE_LENGTH,
            'Flow title must be less than ${max} symbols'
        )
        .required('Flow title is a required field');
});

yup.addMethod(yup.string, 'version', function version(message) {
    const re =
        /^(?:Version|[A-Za-z]+[._])?\d+(?:[._]\d+){2}(?:[-_][A-Za-z0-9]+)*$/;

    return this.test(
        'version',
        message ?? 'Version must be in format x.x.x (e.g. 1.2.3)',
        function (value) {
            if (value === 'latest_version') {
                return true;
            }

            return re.test(value ?? '');
        }
    );
});

yup.addMethod(yup.string, 'urlList', function urlList(message) {
    return this.test(
        'url-list',
        message ?? 'Invalid URLs: ${invalidUrls}',
        function (value) {
            if (!value) return true; // allow empty
            const urls = value
                .split(',')
                .map((url) => url.trim())
                .filter(Boolean);
            const invalidUrls = urls.filter((url) => {
                // Basic URL validation: must start with protocol and be a valid URL
                try {
                    const parsed = new URL(url);
                    return !/^https?:/.test(parsed.protocol);
                } catch {
                    return true;
                }
            });
            if (invalidUrls.length > 0) {
                return this.createError({
                    message: message
                        ? message.replace(
                              '${invalidUrls}',
                              invalidUrls.join(', ')
                          )
                        : `Invalid URLs: ${invalidUrls.join(', ')}`
                });
            }
            return true;
        }
    );
});

export default yup;
